import React, { FC } from 'react';
import { RenderField } from '@zola/zola-ui/src/components/Form/RenderField';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import type { WProductActionView } from '@zola/svc-web-api-ts-client';
import './QuickView.less';

type QuickViewPropType = {
  actions?: WProductActionView[];
  isKit?: boolean;
  hasQuantityField: boolean;
  quantity?: string | number;
  stockMessage?: false | string;
  onQuantityChange: () => void;
  // Action name mapped to a callback for that action
  // e.g { 'SHOW_PDP; this.handleOpendPdpdCallback }
  actionsMap: QuickActionsMap;
};

type QuickActionsMap = {
  ADD_TO_CART: () => void;
  ADD_TO_REGISTRY: () => void;
  SHOW_PDP: () => void;
};

const renderActions = (actions: WProductActionView[], actionsMap: QuickActionsMap) =>
  actions.map((action) =>
    action.tooltip ? (
      <ButtonV2
        key={action.key}
        className="shop-product-tile__btn"
        disabled={action.disabled}
        variant={action.primary ? 'primary' : 'secondary'}
        onClick={
          action.key ? actionsMap[(action.key as unknown) as keyof QuickActionsMap] : undefined
        }
        data-tooltip={action.tooltip}
        compact
      >
        {action.label}
      </ButtonV2>
    ) : (
      <ButtonV2
        key={action.key}
        className="shop-product-tile__btn"
        disabled={action.disabled}
        variant={action.primary ? 'primary' : 'secondary'}
        onClick={actionsMap[(action.key as unknown) as keyof QuickActionsMap]}
        compact
      >
        {action.label}
      </ButtonV2>
    )
  );

const renderKitAction = (actionsMap: QuickActionsMap) => (
  <ButtonV2 className="shop-product-tile__btn" onClick={actionsMap.SHOW_PDP}>
    View Collection
  </ButtonV2>
);

const renderQtyField = (quantity: string | number | undefined, onQuantityChange: () => void) => {
  const inputProps = {
    name: 'quantity',
    value: quantity,
    onChange: onQuantityChange,
    onBlur: onQuantityChange,
    'aria-label': 'Quantity',
  };
  return <RenderField type="number" input={inputProps} />;
};

const renderStockMessage = (stockMessage?: false | string) => {
  const BACKORDER_MESSAGE_PARTIALS = /^(available to ship|backordered)/gi;
  if (!stockMessage) return false;
  return (
    BACKORDER_MESSAGE_PARTIALS.test(stockMessage) && (
      <div className="shop-product-tile__stock-message">{stockMessage}</div>
    )
  );
};

const QuickView: FC<QuickViewPropType> = ({
  actions,
  isKit,
  hasQuantityField,
  quantity,
  onQuantityChange,
  actionsMap,
  stockMessage,
}) => (
  <div className="shop-product-tile__quickview">
    {stockMessage && renderStockMessage(stockMessage)}
    <div className={hasQuantityField ? 'quickview-row' : ''}>
      {hasQuantityField && renderQtyField(quantity, onQuantityChange)}
      <div className="shop-product-tile__actions">
        {actions && renderActions(actions, actionsMap)}
        {isKit && renderKitAction(actionsMap)}
      </div>
    </div>
  </div>
);

export default QuickView;
